(function($) {
    $(document).ready(function() {
        $('.accreditation .plus').on('click touchstart', function(e) {
            e.preventDefault();

            const $currentAccreditation = $(this).closest('.accreditation');
            const $currentPlus = $(this);

            if ($currentAccreditation.hasClass('is-open')) {
                return;
            }

            const $openAccreditation = $('.accreditation.is-open');

            if ($openAccreditation.length) {
                $openAccreditation.find('.minus').hide();
                $openAccreditation.find('.plus').show();
                $openAccreditation.removeClass('is-open');

                $openAccreditation.find('.description').slideUp(300, function() {
                    $currentPlus.hide();
                    $currentAccreditation.find('.minus').show();
                    $currentAccreditation.find('.description').slideDown(300);
                    $currentAccreditation.addClass('is-open');

                    if ($(window).width() < 768) {
                        $('html, body').animate({
                            scrollTop: $currentAccreditation.offset().top - 40
                        }, 300);
                    }
                });
            } else {
                $currentPlus.hide();
                $currentAccreditation.find('.minus').show();
                $currentAccreditation.find('.description').slideDown(300);
                $currentAccreditation.addClass('is-open');

                if ($(window).width() < 768) {
                    $('html, body').animate({
                        scrollTop: $currentAccreditation.offset().top - 40
                    }, 300);
                }
            }
        });

        $('.accreditation .minus').on('click touchstart', function(e) {
            e.preventDefault();

            const $currentAccreditation = $(this).closest('.accreditation');

            $(this).hide();
            $currentAccreditation.find('.plus').show();
            $currentAccreditation.find('.description').slideUp(300);
            $currentAccreditation.removeClass('is-open');
        });
    });
})(jQuery);